import React from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import AppNavbar from "../components/common/AppNavbar";

function USCitizenTravelRegistration() {
  return (
    <>
      <AppNavbar />

      {/* Banner */}
      <div style={{ width: "100%", overflow: "hidden" }}>
        <img
          src="https://mytravel.state.gov/s/sfsites/c/file-asset/DOS_CA_CST_HERO?v=1"
          alt="Smart Traveler Enrollment Program Banner"
          style={{ width: "100%", height: "auto", objectFit: "cover" }}
        />
      </div>

      <Container fluid className="my-5">
        <Row className="justify-content-center">
          <Col md={10}>
            <Card className="shadow border-0 p-4">
              <h4 className="mb-3 fw-bold">
                US Citizens Abroad Advised to Register with State Department
              </h4>

              <p className="text-muted">Updated Travel Advisory</p>

              <p>
                U.S. citizens who are currently traveling, studying, working, or
                living outside the United States — including those in India —
                are encouraged to enroll in the Smart Traveler Enrollment
                Program (STEP). The free service from the U.S. Department of
                State allows American citizens abroad to receive safety alerts,
                travel advisories, and updates from nearby U.S. embassies and
                consulates.
              </p>

              <p>
                Once registered, travelers receive official notifications about
                local conditions that may affect their safety, including
                security warnings, health alerts, demonstrations, and weather
                emergencies. The program also helps U.S. authorities contact
                citizens quickly during crises abroad.
              </p>

              <h5 className="mt-4 fw-bold">Benefits of the STEP Program</h5>

              <ul>
                <li>Receive real-time security alerts from U.S. embassies</li>
                <li>Stay informed about travel advisories and local risks</li>
                <li>
                  Get notifications about natural disasters or emergencies
                </li>
                <li>Allow the embassy to contact you quickly if needed</li>
                <li>Help family members reach you during emergencies</li>
              </ul>

              <h5 className="mt-4 fw-bold">Types of Alerts You May Receive</h5>

              <ul>
                <li>Security or safety alerts</li>
                <li>Demonstration or civil unrest warnings</li>
                <li>Health alerts and disease outbreaks</li>
                <li>Weather warnings and natural disasters</li>
                <li>Travel advisory updates</li>
                <li>Important embassy service updates</li>
              </ul>

              <h5 className="mt-4 fw-bold">How STEP Works</h5>

              <ol>
                <li>Create a secure online account.</li>
                <li>Register your trip or overseas residence.</li>
                <li>
                  Receive alerts and safety messages related to your location.
                </li>
                <li>Update your travel information if your plans change.</li>
              </ol>

              <p className="mt-3">
                The program is recommended for tourists, students, business
                travelers, and Americans living abroad. Enrollment helps the
                nearest U.S. embassy or consulate contact citizens and provide
                guidance during emergencies or major travel disruptions.
              </p>

              <div className="text-center mt-4">
                <Button
                  variant="primary"
                  size="lg"
                  href="https://mytravel.state.gov/s/step"
                  target="_blank"
                >
                  Register with STEP
                </Button>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default USCitizenTravelRegistration;
